"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const PublishIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 32 32" }),
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M20.47,27.87l8-23.08a1,1,0,0,0-1.27-1.28l-23.09,8a1,1,0,0,0,0,1.88l9.59,3.47L17.2,13.4a1.5,1.5,0,1,1,1.39,1.44L15.12,18.3l3.46,9.59A1,1,0,0,0,20.47,27.87Z" }))));
exports.PublishIcon = PublishIcon;
exports.default = exports.PublishIcon;
